import React, { useCallback, useEffect, useState } from 'react'
import InputText from '../input-text'

// component which will handle input text with as a search field
const InputSearch = ({ searchText: searchTextValue, onChangeSearchText, onClearSearchText, ...props}) => {
    const [searchText, setSearchText] = useState(searchTextValue);

    const handleSearchChange = useCallback((value) => {
        setSearchText(value);
        onChangeSearchText && onChangeSearchText(value)
    }, [onChangeSearchText]);

    const handleSearchIconClick = useCallback(() => {
        if (searchText) {
            setSearchText("")

            // call callbacks
            onChangeSearchText && onChangeSearchText("")
            onClearSearchText && onClearSearchText()
        }
    }, [searchText, onChangeSearchText, onClearSearchText]);

    useEffect(() => {
      if(searchTextValue){
        setSearchText(searchTextValue)
      }
    }, [searchTextValue])
    

  return (
    <InputText
        placeholder="Search" 
        hideLabel 
        value={searchText}
        onChange={handleSearchChange}
        iconSrc={`/images/icon/${searchText ? "close.svg" : "search-black.svg"}`}
        onIconClick={handleSearchIconClick}
        {...props}
    />
  )
}

export default InputSearch